/// <reference path="../../include.ts" />

namespace gpx_visualizer_phase2 {

	import View = alm.view.View;
	import TweenCSS = alm.util.TweenCSS;
	import Easing = alm.math.Easing;

	export class Information extends View<JQuery> {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor() {
			super(jQuery('#information'));

			this.initialize();
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		protected implInitialize():JQuery {
			const view:JQuery = this.getView();

			this.dataList = view.find('.datalist');
			this.date = this.dataList.find('.date');
			this.elapsed = this.dataList.find('.elapsed');
			//this.elevation = this.dataList.find('.elevation');
			//this.distance = this.dataList.find('.distance');
			this.terrainType = this.dataList.find('.terrain-type');

			this.legendElevation = view.find('.legend-elevation');
			this.legendGradient = view.find('.legend-gradient');

			this.currentDate = new Date();

			this.floatingStats = new FloatingStats(view.find('.floating-stats'));

			return view;
		}

		protected implReady():void {
			this.floatingStats.ready();
		}

		protected implFinalize():void {
			this.floatingStats.finalize();
		}

		protected implShow(view:JQuery, useTransition:boolean):cmd.Command {
			return new cmd.Serial(
				TweenCSS.fadeIn(view, useTransition ? 500 : 0, Easing.easeOutSine, 'block', false, false),
				new cmd.Func(():void => {
					this.floatingStats.show(useTransition);
				}),
			);
		}

		protected implHide(view:JQuery, useTransition:boolean):cmd.Command {
			return new cmd.Serial(
				TweenCSS.fadeOut(view, useTransition ? 500 : 0, Easing.easeOutSine, true, false, false),
				new cmd.Func(():void => {
					this.floatingStats.hide(useTransition);
				}),
			);
		}





		public setCurrentMarkerPosition(markerPosition:THREE.Vector3):void {
			this.floatingStats.setCurrentMarkerPosition(markerPosition);
		}





		public setCurrentDate(dateTime:number):void {
			DateUtil.setUtcTime(this.currentDate, DateUtil.utcToActivityTimeZone(dateTime));
			const hours = ('00' + this.currentDate.getHours()).slice(-2);
			const minutes = ('00' + this.currentDate.getMinutes()).slice(-2);
			this.date.text(hours + ':' + minutes);
		}

		public setCurrentElevation(elevation:number):void {
			//this.elevation.text(Math.floor(elevation).toLocaleString() + 'm');
			this.floatingStats.setCurrentElevation(elevation);
		}

		public setCurrentDistance(distance:number):void {
			//this.distance.text(Math.floor(distance).toLocaleString() + 'm');
			this.floatingStats.setCurrentDistance(distance);
		}

		public setElapsedTime(elapsedTime:number):void {
			const hours = Math.floor(elapsedTime / 3600000);
			const minutes = ('00' + (Math.floor(elapsedTime / 60000) % 60)).slice(-2);
			this.elapsed.text(hours + ':' + minutes);
		}

		public setElevationLegendValue(values:number[]):void {
			this.setLegendBarLabel(this.legendElevation, values, 'm');
		}

		public setGradientLegendValue(values:number[]):void {
			this.setLegendBarLabel(this.legendGradient, values, '°');
		}

		private setLegendBarLabel(legend:JQuery, values:number[], unit:string):void {
			const height = parseInt(legend.find('.color-bar').css('height'));
			const n = values.length;
			for (let i = 0; i < n; ++i) {
				const label:JQuery = legend.find('.label-' + i);
				const y = height * (1 - (i / (n - 1)));
				label.css('top', y);
				label.text(values[i].toString() + unit);
			}
		}

		public setTerrainType(type:TerrainType = null):void {
			if (type != null) {
				this.terrainType.text(type);
			} else {
				this.terrainType.text('');
			}
			
			switch (type) {
				case TerrainType.SurfaceElevation:
					this.legendElevation.css('display', 'block');
					this.legendGradient.css('display', 'none');
					break;

				case TerrainType.SurfaceGradient:
					this.legendGradient.css('display', 'block');
					this.legendElevation.css('display', 'none');
					break;

				default:
					this.legendElevation.css('display', 'none');
					this.legendGradient.css('display', 'none');
					break;
			}
		}





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		private dataList:JQuery;
		private date:JQuery;
		private elapsed:JQuery;
		//private elevation:JQuery;
		//private distance:JQuery;
		private terrainType:JQuery;

		private legendElevation:JQuery;
		private legendGradient:JQuery;

		private currentDate:Date;

		private floatingStats:FloatingStats;

		public static getInstance():Information { return this.instance || (this.instance = new Information()) };
		private static instance:Information = null;
	}
}
